// Angular
import { HttpClient } from '@angular/common/http';
import { Component, Input, ChangeDetectionStrategy, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';

// Services
import { FormService }  from "libraries/service/form/form.service";

import { GenericForm } from '../generic-the-good-one';
import { Config } from './config';

@Component({
    selector: 'remark-form',
    templateUrl: './remark-form.component.html',
    styleUrls: ['./remark-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemarkFormComponent extends GenericForm {
    @Input()
    public config: Config = Object.freeze(new Config());

    /**
     * Every ViewChild is template
     * With this we give the possibilities to display the template we want dynamically
     * Every template (fieldset) as to have a view child reference
     */
    @ViewChild('remark')
    public remark: TemplateRef<HTMLElement>;

    constructor(public fb: FormBuilder,
        public formService?: FormService,
        public http?: HttpClient) {
        super(fb, formService);
    }

    public init (): void {
        this.form.valueChanges.subscribe((data: any) => {
            this.formService.setData(data);
        });
    }
}
